<template>
  <section>

    <div class="back-button" @click="goToHome">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
        <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" />
      </svg>
      <span class="back-text">{{ programIndv.title }}</span>
    </div>
    <div class="separator-line mobile"></div>
    <div class="program-container">
      <div class="program-image">
        <h1 class="program-title" v-if="programIndv.title" v-html="formatTitle(programIndv.title)"></h1>
        <img v-if="programIndv.webImg" :src="url + `/program-image/${programIndv.id}/${programIndv.webImg}`" alt="">
        <img v-else src="../../assets/templateProgramImg.png" alt="">
        <div class="button-micro ">
        </div>
      </div>
    </div>

    <button v-if="this.programIndv.welcomeFile" @click="getDoc()" class="mobile downloadbutton">
      <p>Descargar Archivos de Bienvenida al Programa</p>
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
        <path
          d="M6.80284 15.8957H4.90397C2.74765 15.8957 1 14.2164 1 12.1444C1 10.0724 2.74765 8.39311 4.90397 8.39311C5.1174 8.39311 5.32796 8.41058 5.53374 8.44277C5.49832 8.17239 5.47823 7.89834 5.47823 7.6206C5.47823 3.96405 8.56293 1 12.3683 1C15.7717 1 18.5971 3.37087 19.156 6.4885C19.4498 6.43516 19.7523 6.40666 20.0624 6.40666C22.7901 6.40666 25 8.53106 25 11.1512C25 13.7722 22.7891 15.8957 20.0624 15.8957H19.1972M14.3189 18.3226L10.1814 23L6.04291 18.3226H8.10353V12.3449H10.1814M14.3371 7.6675L18.4746 12.3449H16.4149V18.3226H12.2592V12.3449H10.1986L14.3371 7.6675Z"
          stroke="url(#paint0_linear_6227_5351)" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
          stroke-linejoin="round" />
        <defs>
          <linearGradient id="paint0_linear_6227_5351" x1="25" y1="12" x2="1" y2="12" gradientUnits="userSpaceOnUse">
            <stop offset="0.23516" stop-color="#4536EF" />
            <stop offset="0.913242" stop-color="#FF00B8" />
          </linearGradient>
        </defs>
      </svg>
    </button>

    <div class="content-container">
      <div class="left-container">
        <div class="title-description-container">
          <h2 class="title">{{ programIndv.title }}</h2>
          <p class="description">
            {{ programIndv.descr }}
          </p>
        </div>

        <button v-if="this.programIndv.welcomeFile" @click="getDoc()" class="downloadbuttonPC">
          <p>Descargar Archivos de Bienvenida al Programa</p>
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M19.7348 5.66591C18.8433 2.52719 15.8682 0.25 12.3683 0.25C8.1772 0.25 4.72823 3.52191 4.72823 7.6206C4.72823 7.62917 4.72824 7.63773 4.72828 7.64629C2.26534 7.73533 0.25 9.68842 0.25 12.1444C0.25 14.6585 2.36192 16.6457 4.90397 16.6457H6.80284C7.02051 16.6457 7.21652 16.5529 7.35353 16.4048V17.5726H6.04291C5.74788 17.5726 5.48025 17.7456 5.35908 18.0146C5.23791 18.2836 5.28571 18.5987 5.48121 18.8196L9.61967 23.497C9.76203 23.6579 9.96657 23.75 10.1814 23.75C10.3963 23.75 10.6008 23.6578 10.7431 23.4969L14.6568 19.0726H16.4149C16.8291 19.0726 17.1649 18.7368 17.1649 18.3226V13.0949H18.4746C18.7696 13.0949 19.0372 12.9219 19.1584 12.6529C19.2795 12.384 19.2318 12.0689 19.0363 11.848L14.8988 7.17058C14.7565 7.00966 14.5519 6.91752 14.3371 6.9175C14.1223 6.91749 13.9177 7.00962 13.7754 7.17052L9.86076 11.5949H8.10353C7.68931 11.5949 7.35353 11.9307 7.35353 12.3449V15.3865C7.21652 15.2384 7.02051 15.1457 6.80284 15.1457H4.90397C3.13338 15.1457 1.75 13.7742 1.75 12.1444C1.75 10.5145 3.13338 9.14311 4.90397 9.14311C5.07648 9.14311 5.24825 9.15724 5.41783 9.18376C5.65127 9.22028 5.88827 9.14465 6.05742 8.97967C6.22656 8.81469 6.30807 8.57965 6.27739 8.34538C6.2457 8.10346 6.22823 7.86212 6.22823 7.6206C6.22823 4.40619 8.94866 1.75 12.3683 1.75C15.4234 1.75 17.9255 3.87513 18.4178 6.62086C18.4529 6.81693 18.5646 6.99096 18.7283 7.10457C18.8919 7.21817 19.094 7.26202 19.29 7.22644C19.5408 7.1809 19.7984 7.15666 20.0624 7.15666C22.4043 7.15666 24.25 8.9731 24.25 11.1512C24.25 13.3299 22.4035 15.1457 20.0624 15.1457H19.1972C18.7829 15.1457 18.4472 15.4814 18.4472 15.8957C18.4472 16.3099 18.7829 16.6457 19.1972 16.6457H20.0624C23.1748 16.6457 25.75 14.2144 25.75 11.1512C25.75 8.08902 23.1759 5.65666 20.0624 5.65666C19.9523 5.65666 19.8431 5.65978 19.7348 5.66591ZM11.8636 11.5949L14.337 8.7994L16.8098 11.5949H16.4149C16.0007 11.5949 15.6649 11.9307 15.6649 12.3449V17.5726H14.3226C14.3203 17.5726 14.318 17.5726 14.3157 17.5726H13.0092V12.3449C13.0092 11.9307 12.6734 11.5949 12.2592 11.5949H11.8636ZM12.6541 19.0726L10.1813 21.8681L7.70792 19.0726H8.10353C8.51774 19.0726 8.85353 18.7368 8.85353 18.3226V13.0949H10.1814C10.1843 13.0949 10.1871 13.0949 10.19 13.0948C10.1929 13.0949 10.1957 13.0949 10.1986 13.0949H11.5092V18.3226C11.5092 18.7368 11.845 19.0726 12.2592 19.0726H12.6541Z"
              fill="url(#paint0_linear_6237_7617)" />
            <defs>
              <linearGradient id="paint0_linear_6237_7617" x1="25.75" y1="12" x2="0.25" y2="12"
                gradientUnits="userSpaceOnUse">
                <stop offset="0.23516" stop-color="#4536EF" />
                <stop offset="0.913242" stop-color="#FF00B8" />
              </linearGradient>
            </defs>
          </svg>
        </button>

        <div class="button-container" v-if="!programIndv.locked">
          <button v-if="!started" class="custom-button" @click="startProgram">
            <span class="button-text">Comenzar Programa</span>
          </button>
          <button v-else class="progress-button" :style="{ '--progress': progress + '%' }" disabled>
            <span class="progress-text">Progreso</span>
          </button>
        </div>
      </div>
      <div class="right-container">
        <h2 class="title-right" v-if="!programIndv.locked">El programa</h2>
        <div class="program-content-container" v-if="!programIndv.locked">
          <div v-for="(item, index) in displayedItems" :key="index">
            <div class="program-item">
              <button class="finish" @click="toggleFinished(index)" :aria-pressed="item.isCompleted"
                aria-label="Marcar como completado">
                <div class="fill" :class="{ filled: item.isCompleted }"></div>
              </button>
              <span class="program-day">{{ item.name }}</span>

              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none"
                class="svg-program">
                <path
                  d="M7.5 0.500122C8.47633 0.500122 8.9645 1.19733 8.9645 2.59174C8.9645 3.21478 8.90532 3.94166 8.78698 4.77237L8.60947 5.92944C8.5503 6.4338 8.50592 6.74532 8.47633 6.864L8.38757 7.44253L10.5178 5.75143C11.9083 4.62403 12.9142 4.06033 13.5355 4.06033C14.1568 4.06033 14.5858 4.29768 14.8225 4.77237C14.9408 4.95038 15 5.15806 15 5.39541C15 6.04812 14.6598 6.58215 13.9793 6.99751C13.3284 7.38319 12.4408 7.78372 11.3166 8.19907L9.31953 9.00012L11.8047 9.97918C12.6923 10.3352 13.3432 10.6467 13.7574 10.9137C14.5858 11.3588 15 11.9225 15 12.6048C15 12.8125 14.8964 13.0944 14.6893 13.4504C14.5118 13.7767 14.1272 13.9399 13.5355 13.9399C12.9438 13.9399 11.9379 13.3762 10.5178 12.2488L8.38757 10.5577L8.47633 11.2253C8.47633 11.3736 8.52071 11.6703 8.60947 12.1153L8.87574 13.6729C8.93491 14.2663 8.9645 14.8596 8.9645 15.453C8.9645 16.0167 8.83136 16.5062 8.56509 16.9216C8.3284 17.3073 7.97337 17.5001 7.5 17.5001C7.02663 17.5001 6.65681 17.3073 6.39053 16.9216C6.15385 16.5062 6.0355 16.0019 6.0355 15.4085C6.0355 14.7855 6.09468 14.0586 6.21302 13.2279L6.39053 12.0708C6.4497 11.5664 6.49408 11.2549 6.52367 11.1362L6.61243 10.5577L4.48225 12.2488C3.09172 13.3762 2.0858 13.9399 1.4645 13.9399C0.843195 13.9399 0.414201 13.7026 0.177515 13.2279C0.0591716 13.0499 0 12.8422 0 12.6048C0 11.9521 0.325444 11.4329 0.976331 11.0472C1.6568 10.6319 2.55917 10.2165 3.68343 9.80117L5.68047 9.00012L3.19527 8.02107C2.33728 7.69471 1.6716 7.38319 1.19822 7.08651C0.399408 6.61182 0 6.04812 0 5.39541C0 5.18773 0.0887574 4.92072 0.266272 4.59436C0.473373 4.23834 0.798816 4.06033 1.2426 4.06033C1.71598 4.06033 2.18935 4.20867 2.66272 4.50536C3.13609 4.77237 3.7426 5.18773 4.48225 5.75143L6.61243 7.44253L6.52367 6.77499C6.52367 6.62665 6.47929 6.32996 6.39053 5.88494L6.12426 4.32735C6.06509 3.73398 6.0355 3.14061 6.0355 2.54724C6.0355 1.92421 6.15385 1.43468 6.39053 1.07866C6.65681 0.692967 7.02663 0.500122 7.5 0.500122Z"
                  fill="url(#paint0_linear_4577_99)" />
                <defs>
                  <linearGradient id="paint0_linear_4577_99" x1="15" y1="9.00012" x2="0" y2="9.00012"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFE711" />
                    <stop offset="1" stop-color="#96FF11" />
                  </linearGradient>
                </defs>
              </svg>

              <!-- <span class="program-description">{{ item.description }}</span> -->
              <div class="component-button" @click="getClassBySesionId(item.id)">
                <button class="rotate-button" @click="toggleExpandItem(index)">
                  <SpecialButtonMicro />
                </button>
              </div>
            </div>
            <div v-if="item.isExpanded">
              <div v-for="(classItem, index) in clasesXsesion" :key="index" class="card-container">
                <div class="card-container-program">
                  <div class="card-image" @click="goToClass(classItem.id, classItem.title, item.id)"
                    v-bind:style="getImageUrl(classItem.image)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="65" viewBox="0 0 37 65" fill="none"
                      class="svg-play">
                      <path
                        d="M2 61.663V3.33699C2 2.45725 3.05411 2.0062 3.69047 2.61363L34.2422 31.7766C34.6549 32.1706 34.6549 32.8294 34.2422 33.2234L3.69048 62.3864C3.05411 62.9938 2 62.5427 2 61.663Z"
                        stroke="white" stroke-width="3" />
                    </svg>
                    <div class="image-header">
                      <svg v-for="n in getIntensity(classItem.intensity)" xmlns="http://www.w3.org/2000/svg" width="18"
                        height="22" viewBox="0 0 18 22" fill="none" class="svg-header">
                        <path
                          d="M1.8 12.2106C1.8 13.4282 2.0889 14.5613 2.6667 15.6101C3.2443 16.6589 4.0385 17.5047 5.0493 18.1475C4.9601 17.9771 4.8962 17.8071 4.8576 17.6373C4.8192 17.4677 4.8 17.29 4.8 17.1042C4.8 16.5449 4.9066 16.0182 5.1198 15.524C5.3328 15.0298 5.6385 14.5822 6.0369 14.181L9 11.2464L11.9745 14.181C12.3731 14.5822 12.677 15.0298 12.8862 15.524C13.0954 16.0182 13.2 16.5449 13.2 17.1042C13.2 17.29 13.1808 17.4677 13.1424 17.6373C13.1038 17.8071 13.0399 17.9771 12.9507 18.1475C13.9615 17.5047 14.7557 16.6589 15.3333 15.6101C15.9111 14.5613 16.2 13.4282 16.2 12.2106C16.2 11.2037 16.015 10.2522 15.645 9.35604C15.275 8.45989 14.74 7.65941 14.04 6.95457C13.64 7.21637 13.22 7.41271 12.78 7.54361C12.34 7.67451 11.89 7.73996 11.43 7.73996C10.1824 7.73996 9.1036 7.32713 8.1936 6.50147C7.2836 5.67581 6.7624 4.65108 6.63 3.42729C5.85 4.0842 5.16 4.7701 4.56 5.485C3.96 6.1999 3.455 6.9287 3.045 7.67139C2.635 8.41428 2.325 9.16835 2.115 9.9336C1.905 10.6988 1.8 11.4578 1.8 12.2106ZM9 13.7814L7.29 15.473C7.07 15.6945 6.9 15.9462 6.78 16.2281C6.66 16.5101 6.6 16.8021 6.6 17.1042C6.6 17.7486 6.835 18.3024 7.305 18.7655C7.775 19.2287 8.34 19.4603 9 19.4603C9.66 19.4603 10.225 19.2287 10.695 18.7655C11.165 18.3024 11.4 17.7486 11.4 17.1042C11.4 16.7819 11.34 16.4849 11.22 16.213C11.1 15.9412 10.93 15.6945 10.71 15.473L9 13.7814ZM8.4 0V2.90683C8.4 3.76189 8.6927 4.4791 9.2781 5.05848C9.8635 5.63785 10.5808 5.92753 11.43 5.92753C11.7976 5.92753 12.148 5.85786 12.4812 5.7185C12.8142 5.57915 13.12 5.37384 13.3986 5.10258L13.9269 4.5661C15.1915 5.38089 16.1865 6.46794 16.9119 7.82726C17.6373 9.18658 18 10.6477 18 12.2106C18 14.7387 17.1277 16.8811 15.3831 18.6378C13.6385 20.3944 11.5108 21.2727 9 21.2727C6.4892 21.2727 4.3615 20.3944 2.6169 18.6378C0.8723 16.8811 0 14.7387 0 12.2106C0 9.8762 0.7554 7.63 2.2662 5.47201C3.777 3.31422 5.8216 1.49022 8.4 0Z"
                          fill="url(#paint0_linear_4796_6333)" />
                        <defs>
                          <linearGradient id="paint0_linear_4796_6333" x1="0" y1="10.6364" x2="18" y2="10.6364"
                            gradientUnits="userSpaceOnUse">
                            <stop offset="0.23516" stop-color="#4536EF" />
                            <stop offset="0.913242" stop-color="#FF00B8" />
                          </linearGradient>
                        </defs>
                      </svg>

                    </div>


                  </div>
                  <div class="card-footer">
                    <div class="header-container">
                      <span class="tittle-program">{{ classItem.title }}</span>
                      <span class="like-button" @click.stop="updateLikeClass(classItem)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                          <mask id="mask0_4_125" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="38" height="38">
                            <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_4_125)">
                            <path
                              d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61063 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70192 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70192 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74288 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                              fill="white" />
                          </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"
                          :class="{ 'like-active': !classItem.liked }">
                          <mask id="mask0_4_124" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="38" height="38">
                            <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_4_124)">
                            <path
                              d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61062 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70193 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70193 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                              fill="white" />
                            <path
                              d="M18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.5429 16.3429 26.4846 18.8572 28.7571Z"
                              fill="#FF3EA6" />
                          </g>
                        </svg>
                      </span>
                    </div>
                    <span class="class-description">{{ classItem.descr }}</span>
                    <div>
                      <span class="class-umana">{{ classItem.method }}</span>
                    </div>
                    <span class="date">{{ classItem.createdAt | formatDate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="index < displayedItems.length - 1" class="separator-line">
            </div>
          </div>
          <div v-if="programItems.length > maxItemsToShow" class="expand-button-container">
            <div class="expand-container">
              <button class="expand-button" @click="toggleExpand">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="none"
                  :class="{ 'rotated': showAllItems }">
                  <path d="M1 1.50012L8 6.50012L15 1.50012" stroke="#B359F8" stroke-width="1.5"
                    stroke-linecap="round" />
                </svg>
                {{ showAllItems ? "Contraer" : "Expandir" }}
              </button>
              <span v-if="started" class="leave-class" @click="leaveProgram">
                Dejar programa
              </span>
            </div>
          </div>
        </div>

        <div>
          <div class="header-coment-container">
            <h2 class="title-right">Comentarios</h2>
            <button class="button-coment" @click="openCommentModal()" v-if="!programIndv.locked">
              <span class="button-text">Dejar comentario</span>
            </button>
          </div>
          <!-- comentarios -->
          <div>
            <div v-for="(comentario, index) in comentarios.data" :key="index" class="comentarioCont">
              <div class="comentario">
                <div class="comentarioInfo">
                  <div class="user">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                      <path
                        d="M7.5 0.00012207C8.47633 0.00012207 8.9645 0.69733 8.9645 2.09174C8.9645 2.71478 8.90532 3.44166 8.78698 4.27237L8.60947 5.42944C8.5503 5.9338 8.50592 6.24532 8.47633 6.364L8.38757 6.94253L10.5178 5.25143C11.9083 4.12403 12.9142 3.56033 13.5355 3.56033C14.1568 3.56033 14.5858 3.79768 14.8225 4.27237C14.9408 4.45038 15 4.65806 15 4.89541C15 5.54812 14.6598 6.08215 13.9793 6.49751C13.3284 6.88319 12.4408 7.28372 11.3166 7.69907L9.31953 8.50012L11.8047 9.47918C12.6923 9.8352 13.3432 10.1467 13.7574 10.4137C14.5858 10.8588 15 11.4225 15 12.1048C15 12.3125 14.8964 12.5944 14.6893 12.9504C14.5118 13.2767 14.1272 13.4399 13.5355 13.4399C12.9438 13.4399 11.9379 12.8762 10.5178 11.7488L8.38757 10.0577L8.47633 10.7253C8.47633 10.8736 8.52071 11.1703 8.60947 11.6153L8.87574 13.1729C8.93491 13.7663 8.9645 14.3596 8.9645 14.953C8.9645 15.5167 8.83136 16.0062 8.56509 16.4216C8.3284 16.8073 7.97337 17.0001 7.5 17.0001C7.02663 17.0001 6.65681 16.8073 6.39053 16.4216C6.15385 16.0062 6.0355 15.5019 6.0355 14.9085C6.0355 14.2855 6.09468 13.5586 6.21302 12.7279L6.39053 11.5708C6.4497 11.0664 6.49408 10.7549 6.52367 10.6362L6.61243 10.0577L4.48225 11.7488C3.09172 12.8762 2.0858 13.4399 1.4645 13.4399C0.843195 13.4399 0.414201 13.2026 0.177515 12.7279C0.0591716 12.5499 0 12.3422 0 12.1048C0 11.4521 0.325444 10.9329 0.976331 10.5472C1.6568 10.1319 2.55917 9.71653 3.68343 9.30117L5.68047 8.50012L3.19527 7.52107C2.33728 7.19471 1.6716 6.88319 1.19822 6.58651C0.399408 6.11182 0 5.54812 0 4.89541C0 4.68773 0.0887574 4.42072 0.266272 4.09436C0.473373 3.73834 0.798816 3.56033 1.2426 3.56033C1.71598 3.56033 2.18935 3.70867 2.66272 4.00536C3.13609 4.27237 3.7426 4.68773 4.48225 5.25143L6.61243 6.94253L6.52367 6.27499C6.52367 6.12665 6.47929 5.82996 6.39053 5.38494L6.12426 3.82735C6.06509 3.23398 6.0355 2.64061 6.0355 2.04724C6.0355 1.42421 6.15385 0.934677 6.39053 0.578657C6.65681 0.192967 7.02663 0.00012207 7.5 0.00012207Z"
                        fill="url(#paint0_linear_1426_5194)" />
                      <defs>
                        <linearGradient id="paint0_linear_1426_5194" x1="15" y1="8.50012" x2="0" y2="8.50012"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FFE711" />
                          <stop offset="1" stop-color="#96FF11" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <p>{{ comentario.user.name }}</p>
                  </div>
                  <span>{{ comentario.createdAt | formatDate }}</span>
                </div>
                <p>
                  {{ comentario.message }}
                </p>
                <div class="comentarioActions">
                  <span class="like-button" @click.stop="updateLike(comentario)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                      <mask id="mask0_4_125" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                        height="38">
                        <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_4_125)">
                        <path
                          d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61063 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70192 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70192 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74288 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                          fill="url(#paint0_linear_1459_2946)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_1459_2946" x1="3.125" y1="14.6731" x2="26.875" y2="14.6731"
                          gradientUnits="userSpaceOnUse">
                          <stop offset="0.23516" stop-color="#4536EF" />
                          <stop offset="0.913242" stop-color="#FF00B8" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"
                      :class="{ 'like-active': !comentario.liked }">
                      <mask id="mask0_4_124" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                        height="38">
                        <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_4_124)">
                        <path
                          d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61062 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70193 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70193 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                          fill="url(#paint0_linear_1459_2946)" />
                        <path
                          d="M18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.5429 16.3429 26.4846 18.8572 28.7571Z"
                          fill="#FF3EA6" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_1459_2946" x1="3.125" y1="14.6731" x2="26.875" y2="14.6731"
                          gradientUnits="userSpaceOnUse">
                          <stop offset="0.23516" stop-color="#4536EF" />
                          <stop offset="0.913242" stop-color="#FF00B8" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                  <button class="answer" v-if="!programIndv.locked" @click="openCommentModal(comentario.id)">
                    <p>Responder</p>
                  </button>
                </div>
              </div>
              <div v-for="(reply, index) in comentario.replies" class="respuesta">
                <div class="decoLine"></div>
                <div class="comentarioInfo">
                  <div class="user">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                      <path
                        d="M7.5 0.00012207C8.47633 0.00012207 8.9645 0.69733 8.9645 2.09174C8.9645 2.71478 8.90532 3.44166 8.78698 4.27237L8.60947 5.42944C8.5503 5.9338 8.50592 6.24532 8.47633 6.364L8.38757 6.94253L10.5178 5.25143C11.9083 4.12403 12.9142 3.56033 13.5355 3.56033C14.1568 3.56033 14.5858 3.79768 14.8225 4.27237C14.9408 4.45038 15 4.65806 15 4.89541C15 5.54812 14.6598 6.08215 13.9793 6.49751C13.3284 6.88319 12.4408 7.28372 11.3166 7.69907L9.31953 8.50012L11.8047 9.47918C12.6923 9.8352 13.3432 10.1467 13.7574 10.4137C14.5858 10.8588 15 11.4225 15 12.1048C15 12.3125 14.8964 12.5944 14.6893 12.9504C14.5118 13.2767 14.1272 13.4399 13.5355 13.4399C12.9438 13.4399 11.9379 12.8762 10.5178 11.7488L8.38757 10.0577L8.47633 10.7253C8.47633 10.8736 8.52071 11.1703 8.60947 11.6153L8.87574 13.1729C8.93491 13.7663 8.9645 14.3596 8.9645 14.953C8.9645 15.5167 8.83136 16.0062 8.56509 16.4216C8.3284 16.8073 7.97337 17.0001 7.5 17.0001C7.02663 17.0001 6.65681 16.8073 6.39053 16.4216C6.15385 16.0062 6.0355 15.5019 6.0355 14.9085C6.0355 14.2855 6.09468 13.5586 6.21302 12.7279L6.39053 11.5708C6.4497 11.0664 6.49408 10.7549 6.52367 10.6362L6.61243 10.0577L4.48225 11.7488C3.09172 12.8762 2.0858 13.4399 1.4645 13.4399C0.843195 13.4399 0.414201 13.2026 0.177515 12.7279C0.0591716 12.5499 0 12.3422 0 12.1048C0 11.4521 0.325444 10.9329 0.976331 10.5472C1.6568 10.1319 2.55917 9.71653 3.68343 9.30117L5.68047 8.50012L3.19527 7.52107C2.33728 7.19471 1.6716 6.88319 1.19822 6.58651C0.399408 6.11182 0 5.54812 0 4.89541C0 4.68773 0.0887574 4.42072 0.266272 4.09436C0.473373 3.73834 0.798816 3.56033 1.2426 3.56033C1.71598 3.56033 2.18935 3.70867 2.66272 4.00536C3.13609 4.27237 3.7426 4.68773 4.48225 5.25143L6.61243 6.94253L6.52367 6.27499C6.52367 6.12665 6.47929 5.82996 6.39053 5.38494L6.12426 3.82735C6.06509 3.23398 6.0355 2.64061 6.0355 2.04724C6.0355 1.42421 6.15385 0.934677 6.39053 0.578657C6.65681 0.192967 7.02663 0.00012207 7.5 0.00012207Z"
                        fill="url(#paint0_linear_1426_5194)" />
                      <defs>
                        <linearGradient id="paint0_linear_1426_5194" x1="15" y1="8.50012" x2="0" y2="8.50012"
                          gradientUnits="userSpaceOnUse">
                          <stop stop-color="#FFE711" />
                          <stop offset="1" stop-color="#96FF11" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <p>{{ reply.user.name }}</p>
                  </div>
                  <span>{{ reply.createdAt | formatDate }}</span>
                </div>
                <p>
                  {{ reply.message }}
                </p>
                <div class="comentarioActions">
                  <span class="like-button" @click.stop="updateLike(reply)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                      <mask id="mask0_4_125" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                        height="38">
                        <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_4_125)">
                        <path
                          d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61063 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70192 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70192 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74288 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                          fill="url(#paint0_linear_1459_2946)" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_1459_2946" x1="3.125" y1="14.6731" x2="26.875" y2="14.6731"
                          gradientUnits="userSpaceOnUse">
                          <stop offset="0.23516" stop-color="#4536EF" />
                          <stop offset="0.913242" stop-color="#FF00B8" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none"
                      :class="{ 'like-active': !reply.liked }">
                      <mask id="mask0_4_124" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                        height="38">
                        <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_4_124)">
                        <path
                          d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61062 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70193 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70193 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                          fill="url(#paint0_linear_1459_2946)" />
                        <path
                          d="M18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.5429 16.3429 26.4846 18.8572 28.7571Z"
                          fill="#FF3EA6" />
                      </g>
                      <defs>
                        <linearGradient id="paint0_linear_1459_2946" x1="3.125" y1="14.6731" x2="26.875" y2="14.6731"
                          gradientUnits="userSpaceOnUse">
                          <stop offset="0.23516" stop-color="#4536EF" />
                          <stop offset="0.913242" stop-color="#FF00B8" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                  <!--
                     <button class="answer" v-if="!programIndv.locked" @click="openCommentModal(reply.id)">
                    <p>Responder</p>
                  </button>-->
                </div>
              </div>
            </div>

          </div>
          <div class="end-coments">
            <span class="see-more-coments">Ver más comentarios</span>
            <button class="button-coment" @click="openCommentModal()" v-if="!programIndv.locked">
              <span class="button-text">Dejar comentario</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <CommentModal :isOpen="isCommentModalOpen" @update:isOpen="isCommentModalOpen = $event"
      @comment-submitted="addComment" />


    <div v-if="regLoading" class="loaderView">
      <div>
        <div class="loaderSpinner"></div>
        <p class="process">{{ process }}</p>
      </div>
    </div>
    <notificacion :tipo="toastType" :titulo="toastTitle" :text="toastSub" :state="toastState" />

  </section>
</template>

<script>
import SpecialButtonMicro from "../specialButtonMicro.vue";
import commentCard from "../commentCard.vue";
import CommentModal from "../commentModal.vue";
import { mapActions } from "vuex";
import Notificacion from "@/components/utils/notificacion.vue";
import dayjs from "dayjs";
import { url } from "@/global/index"
export default {
  name: "ProgramView",
  components: {
    SpecialButtonMicro,
    commentCard,
    CommentModal,
    Notificacion
  },
  data() {
    return {
      liked: false,
      programItems: [],
      showAllItems: false,
      maxItemsToShow: 8,
      isCommentModalOpen: false,
      started: false,

      url,

      toastType: '',
      toastTitle: '',
      toastSub: '',
      toastState: false,
      regLoading: false,
      process: "",


      page: 1,
      pageSize: 100,
      entityId: null,
      type: 'program',
      parentId: undefined,
    };
  },
  async created() {
    await this.getIdentity()
    const programString = localStorage.getItem("program")
    if (!programString) {
      this.goToHome()
    }

    const program = JSON.parse(programString)
    if (!program?.id) {
      this.goToHome()
    }

    this.regLoading = true
    this.process = "Cargando programa"

    await this.getInfoByIdPrm({  // obteniendo programa del backend
      option: "program",
      id: program.id
    })

    this.regLoading = false

    this.started = this.programIndv.hasBeenStarted;

    if (!this.programIndv.id) { // no se encontro ese programa
      this.goToHome()
    }
    this.entityId = this.programIndv.id


    const sessions = Array.isArray(this.programIndv.sessions) ? structuredClone(this.programIndv.sessions) : []
    const format = sessions.map(item => {
      return {
        ...item,
        isExpanded: false
      }
    })
    this.programItems = format

    await this.updateComments()
  },
  computed: {
    identity() {
      return this.$store.getters['admin/getIdentity'];
    },

    programIndv() {
      return this.$store.getters['programindv/data'];
    },

    comentarios() {
      return this.$store.getters['comments/data'];
    },
    clasesXsesion() {
      return this.$store.getters['clases/data'];
    },

    displayedItems() {
      if (this.showAllItems) {
        return this.programItems;
      } else {
        return this.programItems.slice(0, this.maxItemsToShow);
      }
    },
    progress() {
      const finishedItems = this.programItems.filter(
        (item) => item.isCompleted
      ).length;
      const totalItems = this.programItems.length;
      return Math.round((finishedItems / totalItems) * 100);
    },
  },
  methods: {
    ...mapActions("clases", ["getAllInfoCls"]),
    ...mapActions("programindv", ["getInfoByIdPrm"]),
    ...mapActions("comments", ["getAllInfoCmt", "addItemCmt", "deleteItemCmt"]),
    async updateLike(item) {
      this.regLoading = true
      if (item.liked) {
        await this.deleteItemCmt({
          option: 'like',
          id: item.id,
          subvalue: 'comment'
        })
      } else {
        await this.addItemCmt({
          option: 'like',
          item: {
            type: 'comment',
            entityId: item.id
          }
        })
      }

      await this.updateComments()
      this.regLoading = false
    },
    async updateLikeClass(item) {
      this.regLoading = true
      if (item.liked) {
        await this.deleteItemCmt({
          option: 'like',
          id: item.id,
          subvalue: 'fitnessClass'
        })
      } else {
        await this.addItemCmt({
          option: 'like',
          item: {
            type: 'fitnessClass',
            entityId: item.id
          }
        })
      }

      await this.updateProgram(this.programIndv.id)

      this.regLoading = false
    },
    async updateProgram(id) {
      await this.getInfoByIdPrm({
        option: "program",
        id: id
      })
      const sessions = Array.isArray(this.programIndv.sessions) ? structuredClone(this.programIndv.sessions) : []
      const format = sessions.map(item => {
        return {
          ...item,
          isExpanded: false
        }
      })
      this.programItems = format
    },
    async updateComments() {
      await this.getAllInfoCmt(`comment/paginated?page=${this.page}&pageSize=${this.pageSize}&type=${this.type}&entityId=${this.entityId}`)
    },
    getIntensity(intensity) {
      if (intensity === 'Baja') return 1
      if (intensity === 'Media') return 2
      if (intensity === 'Alta') return 3
      return 0
    },
    setNoti(toastState, toastType, toastTitle, toastSub) {
      this.toastState = toastState
      this.toastType = toastType
      this.toastTitle = toastTitle
      this.toastSub = toastSub
      setTimeout(() => {
        this.clearToast();
      }, 5000);
    },

    clearToast() {
      this.toastState = false
    },

    getIdentity: async function () {
      const response = await this.$store.dispatch("admin/getData");
      return response
    },

    toggleLike() {
      this.liked = !this.liked;
    },
    goToHome() {
      this.$router.push({ path: "/web-app", query: { a: "programas" } });
    },

    goToClass(classId, name, sessionId) {
      this.$router.push({ path: "/web-app", query: { a: "clase", id: classId, cN: name, fromProgram: this.programIndv.id, sessionId } });
    },

    toggleExpandItem(index) {
      this.programItems.forEach((item, i) => {
        if (i !== index) {
          item.isExpanded = false;
        }
      });
      this.programItems[index].isExpanded = !this.programItems[index].isExpanded;
    },

    async toggleFinished(index) {
      // Si el programa no ha iniciado, iniciarlo
      if (!this.started) {
        this.startProgram();
      }
      // Alternar el estado de finalización del día
      this.programItems[index].isCompleted =
        !this.programItems[index].isCompleted;

      const item = {
        programSessionId: this.programItems[index].id,
        completed: this.programItems[index].isCompleted,
      }

      try {
        const response = await this.$store.dispatch('programindv/addItemPrm', {
          option: 'session-progress',
          item,
        })

        if (!response.success) throw response;
      } catch (error) {
        console.log("error")
        console.log(error.message)
      }
    },

    toggleExpand() {
      this.showAllItems = !this.showAllItems;
    },
    async getClassBySesionId(id) {
      const response = await this.getAllInfoCls(`session/classes/${id}`)
      console.log(response)
    },
    openCommentModal(id = undefined) {
      this.isCommentModalOpen = true;
      this.parentId = id
    },

    async addComment(newComment) {
      if (!newComment.comment) return
      const response = await this.addItemCmt({
        option: this.parentId === undefined ? 'comment' : 'comment-reply',
        item: {
          message: newComment.comment,
          entityId: this.entityId,
          type: this.type,
          parentId: this.parentId !== undefined ? this.parentId : undefined
        }
      })

      if (!response.success) {
        this.parentId = null
        this.setNoti(true, 'Error', 'ERROR', response.message)
        return
      }

      this.setNoti(true, 'Success', 'Comentario creado con éxito', 'Tu comentario fue enviado a aprobación')
      await this.updateComments()
    },

    startProgram() {
      this.started = true;
    },

    leaveProgram() {
      this.started = false;
      this.programItems.forEach((item) => {
        item.isCompleted = false;
      });
    },

    getImageUrl(image) {
      const imageUrl = image ? `${url}/class-image/${image}` : require('@/assets/programIndividual.jpg')
      return { 'background-image': `url(${imageUrl})` }
    },

    formatTitle(title) {
      if (!/\d/.test(title)) {
        return `<span class="programaTexto">${title}</span>`;
      }
      return title.replace(/(\D+)|(\d+)/g, (match, p1, p2) => {
        if (p1) {
          return `<span class="programaNumero">${p1}</span>`;
        } else if (p2) {
          return `<span class="programaNumero">${p2}</span>`;
        }
        return match;
      });
    },

    async getDoc() {
      if (!this.programIndv.welcomeFile || this.programIndv.welcomeFile == "") {
        return "";
      }
      this.loading = true;
      let src = `${url}/program-image/${this.programIndv.id}/${this.programIndv.welcomeFile}`;
      try {
        const response = await fetch(src);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = this.programIndv.title.includes('.') ? this.programIndv.title.split('.').slice(0, -1).join('.') : this.programIndv.title;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error('Error al descargar el archivo:', err);
      } finally {
        this.loading = false;
      }
    },

  },



  filters: {
    formatDate(value) {
      return dayjs(value).format('DD/MM/YYYY')
    },
    formatHour(value) {
      return dayjs(value).format('HH:mm A')
    }
  }

};
</script>

<style scoped>
section {
  padding: 0 !important;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}

.program-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.rotate-button {
  transform: scaleY(-1);
}

.image-header {
  display: flex;
  justify-content: flex-end;
  padding: 0.6944vw;
  gap: 0.2083vw;
}

.card-image {
  position: relative;
  width: 100%;
  height: 17.0833vw;
  display: flex;
  flex-direction: column;
  border-radius: 1.3889vw 1.3889vw 0vw 0vw;
  background: linear-gradient(180deg,
      rgba(70, 77, 91, 0) 27.78%,
      rgba(70, 77, 91, 0.2) 85.56%), ;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.card-image iframe {
  width: 100%;
}

.card-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 1.0417vw;
  gap: 0.3472vw;
  background: var(--background-gray, #e3e3e9);
  border-radius: 0 0 1.3889vw 1.3889vw;
}

.class-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  align-self: stretch;
  color: var(--Text, #464d5b);
  text-overflow: ellipsis;
  font-family: Manrope;
  font-size: 0.9722vw;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.card-container {
  margin-bottom: 1.0417vw;
}

.card-container-program {
  display: flex;
  width: 52.9861vw;
  padding: 1.0417vw;
  flex-direction: column;
  border-radius: 2.0833vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background: #fff;
}

.header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.svg-header {
  width: 1.25vw;
  height: 1.4773vw;
}

.svg-play {
  width: 2.2917vw;
  height: 4.375vw;
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.svg-program {
  width: 1.0417vw;
  height: 1.1806vw;
}

.class-umana {
  align-self: stretch;
  font-family: "SharpGrotesk-Medium25", sans-serif;
  font-size: 0.8333vw;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
  background: var(--gradient-2,
      linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.expand-button svg {
  transition: transform 0.3s ease;
}

.expand-button svg.rotated {
  transform: rotate(180deg);
}

.tittle-program {
  align-self: stretch;
  font-family: Manrope;
  font-size: 0.6944vw;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: var(--gradient-2,
      linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.expand-button-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 1.0417vw;
}

.date {
  align-self: stretch;
  color: var(--Text, #464d5b);
  text-align: right;
  font-family: Manrope;
  font-size: 0.8333vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.program-image {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 22.9167vw;
  border-radius: 1.3889vw;
  background-size: cover;
  overflow: hidden;
}

.program-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.expand-container {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  gap: 0.6944vw;
  width: 100%;
}

.leave-class {
  position: absolute;
  right: 1.3889vw;
  color: var(--Text, #b359f8);
  font-family: Manrope;
  font-size: 1.0417vw;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
}

.program-title {
  position: absolute;
  font-size: 5.3333vw;
  font-style: normal;
  font-weight: 400;
  line-height: 139.195%;
  text-transform: uppercase;
  text-align: center;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  margin: 0;
  z-index: 5;
}

.program-title ::v-deep .programaNumero {
  font-family: "SharpGrotesk-Medium25" !important;
}

.program-title ::v-deep .programaTexto {
  font-family: "Kemio";

}

/* Botón de Regresar */
.back-button {
  display: flex;
  align-items: center;
  gap: 0.7vw;
  cursor: pointer;
  margin-bottom: 0.5vw;
}

.back-text {
  font-family: Manrope;
  font-size: 1.2vw;
  font-weight: 600;
  color: var(--Text, #464d5b);
}

.content-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding-top: 1.3889vw;
}

.header-coment-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.7361vw;
  padding-bottom: 1.0417vw;
}

.left-container {
  width: 40%;
  padding-right: 3.4722vw;
  position: -webkit-sticky;
  position: sticky;
  top: 0.6944vw;
}

.right-container {
  width: 60%;
}

.title {
  font-family: Manrope;
  font-size: 1.7361vw;
  font-style: normal;
  font-weight: 500;
  padding: 0 0 0.6944vw 0;
  line-height: normal;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.title-right {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.7361vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.description {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.0417vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.7361vw;
}

.custom-button {
  display: flex;
  padding: 0.6944vw 1.3889vw;
  justify-content: center;
  align-items: center;
  gap: 0.6944vw;
  border-radius: 20.8333vw;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  border: none;
  cursor: pointer;
  margin-top: 1.3889vw;
  margin-left: auto;
  width: 100%;
}

.button-text {
  flex: 1 0 0;
  color: #fff;
  text-align: center;
  font-family: Manrope;
  font-size: 1.25vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.button-coment {
  display: flex;
  padding: 0.6944vw 1.3889vw;
  justify-content: center;
  align-items: center;
  gap: 0.6944vw;
  border-radius: 20.8333vw;
  background: var(--purple, #b359f8);
  border: none;
  cursor: pointer;
}

.coment-container,
.program-content-container {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 1.7361vw;
  margin-bottom: 1.3889vw;
  border-radius: 2.0833vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background: #fff;
  align-items: stretch;
  padding: 1.0417vw;
}

.program-item {
  display: flex;
  align-items: center;
  gap: 0.6944vw;
  width: 100%;
  padding: 1.0417vw;
  box-sizing: border-box;
}

.component-button {
  margin-left: auto;
}

.program-day,
.program-description {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.0417vw;
  font-style: normal;
  font-weight: 400;
  line-height: 1.7361vw;
}

.arrow-svg {
  width: 1.0417vw;
  height: 1.1806vw;
}

.finish {
  width: 1.875vw;
  height: 1.875vw;
  border-radius: 2.083333vw;
  border: 0.069444vw solid #b1b1b4;
  overflow: hidden;
  display: flex;
  padding: 0.138889vw;
  cursor: pointer;
  position: relative;
}

.fill {
  width: 100%;
  height: 100%;
  border-radius: 2.083333vw;
  transition: background 0.3s ease-in-out;
}

.filled {
  background: linear-gradient(90deg,
      #4536ef 0%,
      #ff00b8 33%,
      #96ff11 66%,
      #ffe711 100%);
  background-size: 300%;
  background-position: 0% 0;
  animation: cycle 2s ease-in-out infinite alternate;
}

.separator-line {
  height: 0.0694vw;
  background-color: var(--background-gray, #e3e3e9);
  width: calc(100% - 2.0833vw);
  margin: 0 auto;
}

.expand-button {
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  border: none;
  padding-left: 0.6944vw;
  cursor: pointer;
  text-align: center;
  font-family: Manrope;
  font-size: 0.9722vw;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.see-more-coments {
  color: var(--purple, #b359f8);
  font-family: Manrope;
  font-size: 1.0417vw;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
}

.end-coments {
  display: flex;
  justify-content: space-between;
  padding-top: 1.0417vw;
}

@keyframes cycle {
  0% {
    background-position: 0% 0;
  }

  100% {
    background-position: 100% 0;
  }
}

.progress-button {
  position: relative;
  display: flex;
  padding: 0.6944vw 1.3889vw;
  justify-content: center;
  align-items: center;
  gap: 0.6944vw;
  border-radius: 20.8333vw;
  background-color: transparent;
  cursor: not-allowed;
  margin-top: 1.3889vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  width: 100%;
  overflow: hidden;
}

.progress-text {
  color: var(--Text, #464d5b);
  text-align: center;
  font-family: Manrope;
  font-size: 1.25vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  z-index: 2000;
}

.progress-button::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: var(--progress, 0%);
  background: linear-gradient(90deg, #96ff11 33%, #ffe711 100%);
  transition: width 0.5s ease-in-out;
  z-index: 0;
}

.like-button {
  display: flex;
  position: relative;
  flex-direction: row;
  padding-right: 0.6944vw;
  padding-left: 0.6944vw;
  cursor: pointer;
}

.like-button svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.3s ease;
  width: 1.8056vw;
  height: 1.7361vw;
}

.like-active {
  opacity: 0;
}

.comentarioCont {
  display: flex;
  flex-direction: column;
  gap: 0.694444vw;
  padding-bottom: 1.041667vw;
}

.comentario {
  display: flex;
  flex-direction: column;
  gap: 0.694444vw;
  padding: 1.041667vw;
  border-radius: 2.083333vw;
  border: 0.013889vw solid var(--background-gray, #e3e3e9);
  background: #fff;
  width: 55.069444vw;
}

.comentario>p {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.041667vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.comentarioInfo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.comentarioInfo>span {
  color: var(--Text, #464d5b);
  text-align: center;
  font-family: Manrope;
  font-size: 0.694444vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.user {
  display: flex;
  flex-direction: row;
  gap: 0.694444vw;
}

.user svg {
  width: 1.041667vw;
  height: 1.180556vw;
  flex-shrink: 0;
}

.user p {
  font-family: Manrope;
  font-size: 0.833333vw;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background: var(--gradient-2,
      linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: fit-content;
}

.comentarioActions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.like {
  width: 1.388889vw;
  height: 1.388889vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.like svg {
  width: 1.388889vw;
  height: 1.388889vw;
}

.answer p {
  color: var(--purple, #b359f8);
  font-family: Manrope;
  font-size: 1.25vw;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.respuesta {
  display: flex;
  flex-direction: column;
  gap: 0.694444vw;
  padding: 1.041667vw;

  border-radius: 2.083333vw;
  border: 0.069444vw solid var(--background-gray, #e3e3e9);
  background: #fff;
  width: 95%;
  align-self: flex-end;
  position: relative;
}

.respuesta>p {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.041667vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.decoLine {
  position: absolute;
  height: 125%;
  width: 5.4%;
  background-color: transparent;
  left: -5.4%;
  top: -50.4%;
  border-bottom: solid #e3e3e9 0.069444vw;
  border-left: solid #e3e3e9 0.069444vw;
  border-radius: 0 0 0 1.388889vw;
}

.downloadbuttonPC {
  margin-top: 1.493056vw;
  display: flex;
  padding: .694444vw 1.388889vw;
  justify-content: center;
  align-items: center;
  gap: .694444vw;
  width: 100%;

  border-radius: 20.833333vw;
  border: .069444vw solid var(--Text, #464D5B);
}

.downloadbuttonPC p {
  color: var(--Text, #464D5B);
  text-align: center;
  font-family: Manrope;
  font-size: 1.195833vw;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.downloadbuttonPC svg {
  width: 1.666667vw;
  height: 1.527778vw;
}

@media (max-width: 530px) {
  .desktop {
    display: none !important;
  }

  .mobile {
    display: flex;
  }

  .downloadbuttonPC {
    display: none;
  }

  .downloadbutton {
    margin-top: 5vw;
    display: flex;
    padding: 2.325581vw 4.651163vw;
    justify-content: center;
    align-items: center;
    gap: 2.325581vw;
    flex: 1 0 0;

    border-radius: 69.767442vw;
    border: .232558vw solid var(--Text, #464D5B);
  }

  .downloadbutton p {
    color: var(--Text, #464D5B);
    text-align: center;
    font-family: Manrope;
    font-size: 3vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .downloadbutton svg {
    width: 5.581395vw;
    height: 5.116279vw;
  }

  .back-text {
    flex-grow: 1;
    font-size: 4.5vw;
    text-align: center;
  }

  .back-button {
    padding-bottom: 5vw;
  }

  .back-button svg {
    width: 2.25vw;
    height: auto;
  }

  .separator-line {
    width: 100%;
    height: 0.0694vw;
    min-height: 0.0694vw;
    background: #e3e3e9;
  }

  .program-container {
    width: 100%;
    padding-top: 5vw;

  }

  .program-image {
    width: 100%;
    height: 53.1818vw;
    border-radius: 4.5455vw;
    background: url("@/assets/programaImg1.jpg") no-repeat center -11.3636vw;
    background-position: left -11.3636vw top -20.4545vw;
    clip-path: polygon(4.988% 0%, 95.012% 0%, 95.012% 0%, 95.821% 0.112%, 96.589% 0.436%, 97.305% 0.954%, 97.958% 1.649%, 98.539% 2.503%, 99.038% 3.499%, 99.443% 4.619%, 99.746% 5.845%, 99.935% 7.161%, 100% 8.547%, 100% 71.81%, 100% 71.81%, 99.935% 73.197%, 99.746% 74.512%, 99.443% 75.738%, 99.038% 76.858%, 98.539% 77.854%, 97.958% 78.708%, 97.305% 79.403%, 96.589% 79.922%, 95.821% 80.245%, 95.012% 80.357%, 92.748% 80.357%, 92.748% 80.357%, 91.939% 80.469%, 91.172% 80.793%, 90.456% 81.311%, 89.802% 82.006%, 89.221% 82.861%, 88.723% 83.856%, 88.317% 84.976%, 88.015% 86.203%, 87.826% 87.518%, 87.76% 88.904%, 87.76% 91.453%, 87.76% 91.453%, 87.695% 92.839%, 87.506% 94.155%, 87.204% 95.381%, 86.798% 96.501%, 86.3% 97.497%, 85.718% 98.351%, 85.065% 99.046%, 84.349% 99.564%, 83.582% 99.888%, 82.773% 100%, 4.988% 100%, 4.988% 100%, 4.179% 99.888%, 3.411% 99.564%, 2.695% 99.046%, 2.042% 98.351%, 1.461% 97.497%, 0.962% 96.501%, 0.557% 95.381%, 0.254% 94.155%, 0.065% 92.839%, 0% 91.453%, 0% 8.547%, 0% 8.547%, 0.065% 7.161%, 0.254% 5.845%, 0.557% 4.619%, 0.962% 3.499%, 1.461% 2.503%, 2.042% 1.649%, 2.695% 0.954%, 3.411% 0.436%, 4.179% 0.112%, 4.988% 0%);
    background-size: 170%;
    overflow: hidden;
    justify-content: start;
    align-items: end;
  }

  .program-title {
    padding: 2.2727vw;
    font-size: 13.6364vw;
    text-align: start;
    background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
    background-clip: text;
    line-height: 80%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    margin: 0;
  }

  .button-micro {
    width: 100%;
    display: flex;
    justify-content: end;
    z-index: 2;
  }

  .left-container {
    width: 100%;
    padding-right: none;
    position: relative;
  }

  .title {
    width: 40%;
    font-size: 2.7273vw;
    font-weight: 600;
  }

  .description {
    flex: 1;
    font-size: 2.7273vw;
    line-height: 4.7727vw;
  }


  .right-container {
    display: relative;
    padding-top: 10vw;
    width: 100%;
  }

  .content-container {
    flex-direction: column;
    width: 100%;
    padding-top: 5vw;
  }

  .custom-button {
    padding: 5vw 1.3889vw;
    border-radius: 68.1818vw;
    width: 100%;
    height: 9.0909vw;
  }

  .button-text {
    font-size: 3.4091vw;
  }

  .progress-button {
    padding: 0.6944vw 1.3889vw;
    gap: 0.6944vw;
    border-radius: 20.8333vw;
    width: 100%;
    height: 9.0909vw;
  }

  .progress-text {
    font-size: 3.4091vw;
  }

  .title-description-container {
    display: flex;
    flex-direction: row;
    gap: 1vw;
    padding-bottom: 5vw;
  }

  .title-right {
    font-size: 5.6818vw;
  }

  .program-day,
  .program-description {
    font-size: 3.4091vw;
  }

  .svg-program {
    width: 3.4091vw;
    height: 3.8636vw;
  }

  .fill {
    width: 100%;
    height: 100%;
    border-radius: 3.0682vw;
    transition: background 0.3s ease-in-out;
  }

  .finish {
    width: 6.1364vw;
    height: 6.1364vw;
    padding: .4545vw;
    border-radius: 3.0682vw;
  }

  .program-item {
    padding: 2.2727vw;
    gap: 2.2727vw;
  }

  .expand-button {
    padding-left: 2.2727vw;
    font-size: 2.7273vw;
  }

  .leave-class {
    right: 1.1364vw;
    font-size: 2.7273vw;
  }

  .button-coment {
    display: flex;
    padding: 2.2727vw 4.5455vw;
    gap: 2.2727vw;
    border-radius: 68.1818vw;
  }

  .end-coments {
    padding-bottom: 20vh;
  }

  .comentario {
    width: 100%;
    padding: 3.4091vw;
    gap: 2.2727vw;
    border-radius: 6.8182vw;
    border: .2273vw solid var(--background-gray, #E3E3E9);
  }

  /* AQUI EMPIEZAN LOS ESTILOS QUE ME FALTAN */
  .comentario>p {
    font-size: 2.7273vw;
  }

  .comentarioInfo>span {
    font-size: 2.2727vw;
  }

  .user {
    display: flex;
    flex-direction: row;
    gap: 2.2727vw;
  }

  .user svg {
    width: 3.4091vw;
    height: 3.8636vw;
    flex-shrink: 0;

  }

  .user p {
    font-size: 2.7273vw;
  }

  .like {
    width: 4.5455vw;
    height: 4.5455vw;
  }

  .like svg {
    width: 4.5455vw;
    height: 4.5455vw;
  }

  .like-button svg {
    width: 4.5455vw;
    height: 4.5455vw;
  }

  .answer p {
    font-size: 2.2727vw;
  }

  .respuesta {
    padding: 2.2727vw;
    gap: 2.2727vw;
    border-radius: 4.2727vw;
    border: .2273vw solid var(--background-gray, #E3E3E9);
  }

  .respuesta>p {
    color: var(--Text, #464d5b);
    font-family: Manrope;
    font-size: 2.2727vw;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .decoLine {
    position: absolute;
    height: 125%;
    width: 5.4%;
    background-color: transparent;
    left: -5.4%;
    top: -50.4%;
    border-bottom: solid #e3e3e9 0.069444vw;
    border-left: solid #e3e3e9 0.069444vw;
    border-radius: 0 0 0 1.388889vw;
  }

  .see-more-coments {
    font-size: 2.7273vw;
  }

  .card-container-program {
    width: 100%;
  }

  .card-image {
    width: 100%;
    height: 29.3182vw;
  }

  .card-footer {
    width: 100%;
    height: auto;
    padding: 2.2727vw;
    gap: 1.1364vw;
    background: var(--background-gray, #e3e3e9);
    border-radius: 0 0 1.3889vw 1.3889vw;
  }

  .tittle-program {
    font-size: 2.2727vw;
  }

  .class-description {
    font-size: 2.7273vw;
  }

  .class-umana {
    font-size: 2.2727vw;
  }

  .date {
    font-size: 2.2727vw;
  }

  .svg-play {
    width: 3.4091vw;
    height: auto;
    top: 20%;
    left: 5%;
    transform: translate(-50%, -50%);
  }
}
</style>

<style>
.no-scroll {
  overflow: hidden;
}
</style>
